import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

/**
 * Shared "What is KAP?" explainer section — used on Homepage (inline)
 * and all specialty landing pages (via SpecialtyLocationPage template,
 * plus the Group Immersion page).
 */
export const WhatIsKAP = ({ background = "bg-white" }) => (
  <section
    className={`py-20 md:py-24 px-6 md:px-12 ${background}`}
    data-testid="what-is-kap-section"
  >
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-flex items-center gap-2 text-primary font-medium text-sm uppercase tracking-[0.18em]">
          <Sparkles className="h-4 w-4" />
          The Modality
        </span>
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mt-4 leading-tight">
          What is KAP?
        </h2>

        <div className="mt-8 space-y-5 text-lg text-muted-foreground leading-relaxed">
          <p>
            KAP is another term for Ketamine-Assisted Psychotherapy. Ketamine is a
            legal psychedelic that can be taken in many forms; I utilize the tablet
            form for my telemedicine sessions.
          </p>
          <p>
            KAP works with the NMDA receptors in the brain, which enhances
            neuroplasticity. This is why KAP helps you create new neural pathways
            that help your brain solve complex challenges in new ways that it never
            could before.
          </p>
          <p>
            You can expect to experience enhanced therapeutic breakthroughs within
            the first dosing session. After the dosing session, we do the
            psychedelic integration session to maximize the benefits of the
            ketamine.
          </p>
          <p>
            KAP goes to the root of the issues that caused you to be a
            hyper-independent woman — it helps you effectively process the things
            that kept you in this loop. The changes continue on even long after
            you&rsquo;ve completed your journey with me.
          </p>
          <p className="italic text-primary font-medium">
            After many years in talk therapy, I thought I would be in therapy my
            whole life. Although each case is unique, after KAP came into my life,
            I haven&rsquo;t been in therapy since.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WhatIsKAP;
